import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import SettingForm from 'views/admin/settings/SettingForm'

const Settings = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <SettingForm />
      </Route>
    </Switch>
  )
}

export default Settings
